import { flattenReduxFormProps } from 'decorators';
import { StarInput } from 'components/form/StarInput';

export default flattenReduxFormProps(StarInput);
